/**
 * Wraps any child element so 5 rapid taps within 1.5s navigates to
 * /diagnostics. Intended for the Celey wordmark / brand logo.
 *
 * Safe to remove pre-App-Store: delete this file and remove the wrapper
 * from any callers.
 */
import React, { useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const FiveTapToDiagnostics = ({ children, as: Tag = 'div', ...rest }) => {
  const navigate = useNavigate();
  const taps = useRef([]);

  const handleTap = useCallback(() => {
    const now = Date.now();
    // Keep only taps within the last 1.5 seconds.
    taps.current = [...taps.current.filter((t) => now - t < 1500), now];
    if (taps.current.length >= 5) {
      taps.current = [];
      try { navigate('/diagnostics'); } catch { /* noop */ }
    }
  }, [navigate]);

  return (
    <Tag onClick={handleTap} {...rest}>
      {children}
    </Tag>
  );
};

export default FiveTapToDiagnostics;
